import { render, staticRenderFns } from "./EbSignUpForm.vue?vue&type=template&id=fa404a7c"
import script from "./EbSignUpForm.vue?vue&type=script&lang=js"
export * from "./EbSignUpForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports